/**
 * Default HttpClient which is capable of performing of HTTP GET using the specified access token.
 */
var DefaultHttpClient =
/** @class */
function () {
  function DefaultHttpClient(accessToken) {
    this._accessToken = accessToken;
  }

  DefaultHttpClient.prototype.Get = function (uri) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      fetch(uri, {
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Authorization: "Bearer " + _this._accessToken
        }
      }).then(function (response) {
        if (response.ok) {
          response.json().then(function (json) {
            resolve(json);
          }).catch(function (error) {
            reject(error);
          });
        } else {
          if (response.status === 401 || response.status === 403) {
            resolve(undefined);
          } else {
            reject(response.statusText);
          }
        }
      });
    });
  };

  return DefaultHttpClient;
}();

export { DefaultHttpClient };